<div class="modal-body _pop-overlay _math-key-popup">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup _all-file-download">
      <!--start check box popup-->
      <div class="_math-key-mid key-popup">
        <div class="_top-icon">
          <div class="key-img">
            <img src="assets/images/key_2_icon-white.svg" class="kiwiwrite" aria-hidden="true" />
          </div>
        </div>
        <div class="heading">
          {{ 'loginUserCodePopupHeading' | translate }}
        </div>
        <p>
          {{ 'loginUserCodePopupDescription' | translate }}
        </p>
        <form class="_form-section" [formGroup]="useCodeForm" (ngSubmit)="useCode()">
          <div class="form-field">
            <div class="_field _full _icons">
              <label>
                {{ 'loginUserCodePopupCode' | translate }}
              </label>
              <input type="text" autocomplete="off" formControlName="licenseCode" />
              <label class="error-msg" *ngIf="f.licenseCode.errors?.required && f.licenseCode.touched">
                {{ 'licenseCode' | translate }}
              </label>
            </div>
            <!--end-->
          </div>
          <!--end-->
          <div class="_popup-btn">
            <button type="button" class="button" (click)="toCancel()">
              {{ 'cancel' | translate }}
            </button>
            <button type="submit" class="button secondary">
              {{ 'ok' | translate }}
            </button>
          </div>
        </form>
      </div>
      <!--end check box popup-->
    </div>
  </div>
</div>
